export const CREWS_TRANSLATIONS = {
  en: {
    crews: {
      title: 'Crew Sheet',
      refresh: 'Refresh',
      lastUpdate: 'Last Update',
      search: 'Search',
      inUse: 'In use',
      unassigned: 'Unassigned',
      services: '{{count}} Services',
      filters: {
        area: 'Area',
        region: 'Region',
        date: 'Date',
        selectArea: 'Select area',
        selectDate: 'Select date',
        selectRegion: 'Select region',
        reset: 'Reset Filters',
        execute: 'Execute',
      },
      actions: {
        configuration: 'Crew Configuration',
        printAll: 'Print all Tickets',
        downloadAll: 'Download all Tickets',
        expandAll: 'Expand all Crews',
        cancel: 'Cancel',
        save: 'Save',
        assign: 'Assign',
        deassign: 'Deassign',
        remove: 'Remove',
        undo: 'Undo',
      },
      sections: {
        assignedCrews: 'Assigned Crews',
        unassignedServices: 'Unassigned Services',
      },
      menu: {
        open: 'Open actions',
        changeCrew: 'Change Crew',
        viewOrder: 'View Order',
      },
      tooltip: {
        order: 'Order',
        work: 'Work',
        deliveryPoint: 'Delivery point (POD)',
        deliveryAddress: 'Delivery address (POD)',
        volume: 'Volume',
        bombId: 'Bomb ID',
        crew: 'Crew',
        schedule: 'Schedule',
        conflict: 'Overlap conflict',
        assigned: 'Assigned',
        overlap: 'Overlap',
      },
      empty: {
        noCrewsHeader: 'No crews to show',
        noCrewsBody: 'There are no active crews for the selected filters.',
        noUnassignedHeader: 'No unassigned services',
        noUnassignedBody: 'There are no unassigned services to show.',
        noResultsHeader: 'No matches found',
        noResultsBody: 'Try another search term.',
      },
      configuration: {
        title: 'Crew Configuration',
        crewLabel: 'Crew',
        regionLabel: 'Region',
        crewPlaceholder: 'Enter crew name',
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Enter description',
        activeLabel: 'Active',
        addCrew: 'Add Crew',
        deletedTitle: 'Crews Deleted',
        deletedSubtitle: '{{count}} Crews - Click undo to restore.',
        subtitle: '{{count}} Crews - Click the pencil to edit.',
        requiredError: 'Complete crew name, region, and description before saving.',
        duplicateError: 'Crew name and region already exist in another row.',
        validationError: 'Review crew configuration errors before saving.',
        saveSuccess: 'Crew configuration saved: {{changes}}.',
        saveError: 'Crew configuration could not be saved.',
        createdChanges: '{{count}} created',
        updatedChanges: '{{count}} updated',
        deletedChanges: '{{count}} deleted',
        statusInUse: 'In Use',
        statusActive: 'Active',
        statusInactive: 'Inactive',
      },
      assignment: {
        title: 'Crew Assignment for Service {{order}}',
        editSubtitle: 'Actual Crew Assigned: {{crewName}} - {{crewDescription}}',
        subtitle: '{{day}} – {{start}} to {{end}} hrs.',
        serviceCount: '{{count}} Services',
        overlapWarning: 'The crew is already in use. Do you want to continue?',
        assignSuccess: 'The service was assigned successfully.',
        unassignSuccess: 'The service was unassigned successfully.',
        assignError: 'An error occurred while assigning the service.',
        unassignError: 'An error occurred while unassigning the service.',
      },
    },
  },
  es: {
    crews: {
      title: 'Hoja de Cuadrillas',
      refresh: 'Refrescar',
      lastUpdate: 'Última Actualización',
      search: 'Buscar',
      inUse: 'En uso',
      unassigned: 'Sin asignar',
      services: '{{count}} Servicios',
      filters: {
        area: 'Área',
        region: 'Región',
        date: 'Fecha',
        selectArea: 'Seleccionar área',
        selectDate: 'Seleccionar fecha',
        selectRegion: 'Seleccionar región',
        reset: 'Restablecer Filtros',
        execute: 'Ejecutar',
      },
      actions: {
        configuration: 'Configuración de Cuadrillas',
        printAll: 'Imprimir todos los Tickets',
        downloadAll: 'Descargar todos los Tickets',
        expandAll: 'Expandir todas las Cuadrillas',
        cancel: 'Cancelar',
        save: 'Guardar',
        assign: 'Asignar',
        deassign: 'Desasignar',
        remove: 'Eliminar',
        undo: 'Deshacer',
      },
      sections: {
        assignedCrews: 'Cuadrillas Asignadas',
        unassignedServices: 'Servicios No Asignados',
      },
      menu: {
        open: 'Abrir acciones',
        changeCrew: 'Cambiar Cuadrilla',
        viewOrder: 'Ver Pedido',
      },
      tooltip: {
        order: 'Pedido',
        work: 'Trabajo',
        deliveryPoint: 'Punto de entrega (POD)',
        deliveryAddress: 'Dirección de entrega (POD)',
        volume: 'Volumen',
        bombId: 'ID de Bomba',
        crew: 'Cuadrilla',
        schedule: 'Horario',
        conflict: 'Conflicto de traslape',
        assigned: 'Asignado',
        overlap: 'Traslape',
      },
      empty: {
        noCrewsHeader: 'No hay cuadrillas para mostrar',
        noCrewsBody: 'No hay cuadrillas activas para los filtros seleccionados.',
        noUnassignedHeader: 'No hay servicios sin asignar',
        noUnassignedBody: 'No hay servicios sin asignar para mostrar.',
        noResultsHeader: 'No se encontraron coincidencias',
        noResultsBody: 'Intenta con otro término de búsqueda.',
      },
      configuration: {
        title: 'Configuración de Cuadrillas',
        crewLabel: 'Cuadrilla',
        regionLabel: 'Región',
        crewPlaceholder: 'Ingrese el nombre de la cuadrilla',
        descriptionLabel: 'Descripción',
        descriptionPlaceholder: 'Ingrese la descripción',
        activeLabel: 'Activo',
        addCrew: 'Agregar Cuadrilla',
        deletedTitle: 'Cuadrillas Eliminadas',
        deletedSubtitle: '{{count}} Cuadrillas - Click en deshacer para restaurar.',
        subtitle: '{{count}} Cuadrillas - Haz clic en el lápiz para editar.',
        requiredError: 'Completa nombre, región y descripción de la cuadrilla antes de guardar.',
        duplicateError: 'El nombre y la región de la cuadrilla ya existen en otro registro.',
        validationError: 'Revisa los errores de configuración de cuadrillas antes de guardar.',
        saveSuccess: 'Configuración de cuadrillas guardada: {{changes}}.',
        saveError: 'No se pudo guardar la configuración de cuadrillas.',
        createdChanges: '{{count}} creadas',
        updatedChanges: '{{count}} actualizadas',
        deletedChanges: '{{count}} eliminadas',
        statusInUse: 'En Uso',
        statusActive: 'Activa',
        statusInactive: 'Inactiva',
      },
      assignment: {
        title: 'Asignación de Cuadrilla para el Servicio {{order}}',
        editSubtitle: 'Cuadrilla Actual Asignada: {{crewName}} - {{crewDescription}}',
        subtitle: '{{day}} – {{start}} a {{end}} hrs.',
        serviceCount: '{{count}} Servicios',
        overlapWarning: 'La cuadrilla ya se encuentra en uso. ¿Deseas continuar?',
        assignSuccess: 'El servicio se asignó correctamente.',
        unassignSuccess: 'El servicio se desasignó correctamente.',
        assignError: 'Ocurrió un error al asignar el servicio.',
        unassignError: 'Ocurrió un error al desasignar el servicio.',
      },
    },
  },
};
